export default "__VITE_ASSET__DTHw8K_q__"